import clsx from 'clsx';
import HelperText from './shared/HelperText';
import ErrorText from './shared/ErrorText';
import RadioList, {RadioListProps} from 'components/basic/RadioList';
import { Label } from '@/shadcn_components/ui/label';
import { InputProps, useInput } from '../../hooks/useInput';

export type RadioInputProps = InputProps &
  Omit<RadioListProps, 'value' | 'onChange'> & {containerClassName?: string};

const RadioInput = (props: RadioInputProps) => {
  const {
    field: {onChange, value},
    fieldState,
  } = useInput(props);
  const {containerClassName, source} = props;
  const radioListProps: Omit<RadioListProps, 'value' | 'onChange'> = props;

  return (
    <div className={clsx('w-full space-y-1', containerClassName)}>
      <Label>{props.label}</Label>
      <RadioList name={source} value={value} onChange={onChange} {...radioListProps} />
      <HelperText helperText={props.helperText} />
      <ErrorText {...fieldState} />
    </div>
  );
};

export default RadioInput;
